"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _auth = require("@/utils/auth");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ChangeRole',
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      formLabelWidth: '120px',
      isLoading: false,
      role: '',
      roleList: '',
      token: '',
      errorKeys: [],
      errorInfo: {}
    };
  },
  computed: {
    isVisible: {
      get: function get() {
        return this.isShow;
      },
      set: function set(val) {
        this.$emit('update:isShow', val);
      }
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)',
          target: '.model-content'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.roleList = this.$store.getters.userInfo.roleCodes || [];
    this.role = this.$store.getters.roles[0];
    this.token = (0, _auth.getToken)();
  },
  methods: {
    getRoleName: _index.getRoleName,
    changeRole: function changeRole() {
      var _this = this;
      var param = {
        roleCode: this.role
      };
      this.isLoading = true;
      if (this.role == "Leadership") {
        this.$message.error(this.$t('navbar.changeRole_noPermission'));
        this.isLoading = false;
        return;
      }
      this.$api.login.sfeChangeRole(param, this.token).then(function (res) {
        _this.isLoading = false;
        if (res.success) {
          if (res.data.menus && res.data.menus.length) {
            // 有菜单可以访问
            _this.$store.dispatch('user/setRoles', [_this.role]);
            _this.$store.dispatch('user/setTeamType', res.data.teamType);
            _this.$store.dispatch('nocache/setAddRoute', {
              isAddRoute: true
            });
            _this.$store.dispatch('permission/generateRoutes', res.data.menus).then(function (res) {
              if (_this.$route.path === '/dashboard') {
                _this.$router.push({
                  path: '/dashboard',
                  query: {
                    needRefresh: true
                  }
                });
              } else {
                _this.$router.push({
                  path: '/dashboard'
                });
              }
            });
            _this.$store.dispatch('permission/generateFunctions', res.data.functions);
            _this.isVisible = false;
            _this.$message.success(_this.$t('navbar.changeRole_success'));
          } else {
            // 没有菜单可以访问
            _this.$message.error(_this.$t('navbar.changeRole_noPermission'));
          }
        } else {
          _this.$message.error(_this.$t('navbar.changeRole_fail'));
        }
      }).catch(function (err) {
        console.log(err);
        _this.isLoading = false;
        _this.$message.error(_this.$t('navbar.changeRole_fail'));
      });
    }
  }
};